import { render } from "./ControleDeSetores.vue?vue&type=template&id=027e73a0"
import script from "./ControleDeSetores.vue?vue&type=script&lang=js"
export * from "./ControleDeSetores.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__